import { useEffect, useState } from 'react';
import '../styles.css';
import CardModal from './CardModal';
import Card from './Card';
import { ranks } from '../data/data';
import { Trash, X } from 'lucide-react';

const CardsPage = ({ cards, fetchCards, cardTypes }) => {
  /* MODAL */
  
  const [cardModalIsOpen, setCardModalIsOpen] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  
  const openCardModal = (card) => {
    document.body.classList.add('no-scroll');
    setSelectedCard(card);
    setCardModalIsOpen(true);
  };

  const closeCardModal = () => {
    document.body.classList.remove('no-scroll');
    setCardModalIsOpen(false);
    setSelectedCard(null);
    fetchCards();
  };

  /* Filters */

  const [filters, setFilters] = useState(ranks);
  const [textFilter, setTextFilter] = useState("");
  const [filteredCards, setFilteredCards] = useState(cards);

  useEffect(() => {
    setFilteredCards(cards.filter(c => 
          ((c.title+c.description+c.id).toLowerCase().includes(textFilter.toLowerCase().trim()))
           && (!filters.some(rank => rank.active) || filters[c.rank].active))
           .sort((a,b) => (b.rank-a.rank)));
  },[cards,filters,textFilter])

  return (
    <div>
      <h2 className='text-center'>Toutes les Cartes</h2>
      <div className='filter-container'>
        <div className='filter-phone-block'>
          <input className='filter-element' type="text" value={textFilter} placeholder="Rechercher..." onChange={(e) => setTextFilter(e.target.value)}/>
          <div className='filter-cross'
            onClick={() => setTextFilter("")}
          ><Trash/></div>
        </div>
        <div className='filter-phone-block'>
          {filters.map((filter,index) => (
            <div key={filter.id} className={`filter-element ${filter.active ? 'active' : ''}`} style={{color:filter.color}}
              onClick={() => setFilters(filters.map((filter,i) =>
                i === index ? { ...filter, active: !filter.active } : filter
              ))}
            >{filter.short}</div>
          ))}
          <div className='filter-cross'
            onClick={() => setFilters(filters.map((filter) => ({...filter, active: false})))}
          ><X/></div>
        </div>
      </div>
      <div className='filter-result'>{filteredCards.length} carte{filteredCards.length>1?'s':''}</div>

      <div className='card-container'>
        {filteredCards.map(c => <Card key={c.id} card={c} openCardModal={openCardModal} />)}
      </div>

      <CardModal
        isOpen={cardModalIsOpen}
        onRequestClose={closeCardModal}
        card={selectedCard}
        cardTypes={cardTypes}
      />

      <button className='big-button' onClick={()=>{openCardModal({id:-1,title:"",rank:0,type:0,description:""})}}>+ Ajouter une carte</button>
    </div>
  );
};

export default CardsPage;
